import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/layout-contain.css';
import './styles/mobile-perf.css';
import './styles/landing-member-cta.css';
import App from './App';
import { captureAttributionFromLocation } from './utils/attribution';
import { bootstrapGoogleAnalytics } from './utils/googleAnalytics';

bootstrapGoogleAnalytics();
captureAttributionFromLocation();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
